import { clearErrors } from '@/reducers/auth';
import { AppDispatch } from '@/root/store';
import { FormatCurrency } from '@/routes/root';
import { ShowProfile } from '@/services/profile';
import moment from 'moment';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { DashboardCard } from '../../dashboard/_card';
import { SectionItem, SectionTabs } from '../../_nav/section';

export function OrgSettingBillsLayout() {
  const location = useLocation();
  const dispatch: AppDispatch = useDispatch();

  const pathArray = location.pathname.split('/').slice(2);
  const section = pathArray[1];

  const [formData, setFormData] = useState({
    amount: 0,
    type: '',
    assigned_type: '',
  });

  const { profile, errors } = useSelector((state: any) => state.profile);

  const setData = (value: string, element: string) => {
    setFormData({ ...formData, [element]: value });

    dispatch(clearErrors());
  };

  useEffect(() => {
    dispatch(ShowProfile());
  }, []);

  const sections: Record<string, string> = {
    transactions: 'Transaksi',
  };

  return !section ? (
    <Navigate to='transactions' />
  ) : (
    <>
      <div className='flex gap-6'>
        <DashboardCard
          variant='whiteAlt'
          name={`Tagihan ${moment().format('MMMM')}`}
          topLabel={{
            primary: <FormatCurrency amount={10000} />,
          }}
          className='w-[268px]'
        />
      </div>
      <SectionTabs grow={false}>
        {Object.entries(sections).map(([key, value]) => {
          return (
            <SectionItem
              id={key}
              key={key}
              name={value}
              isCurrent={section === key}
            />
          );
        })}
      </SectionTabs>
      <Outlet />
    </>
  );
}
